import { render, staticRenderFns } from "./CommentInfo.vue?vue&type=template&id=3995faf2&scoped=true&"
import script from "./CommentInfo.vue?vue&type=script&lang=js&"
export * from "./CommentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995faf2",
  null
  
)

export default component.exports